import { render } from "./HeroiconsOutlineTicket.vue?vue&type=template&id=aa81b12e"
const script = {}

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineTicket.vue"]])

export default __exports__